/**
 * 可全局引用的 消息提示 方法
 */

export const MixinsMessage = {
  methods: {
    /** 消息提示 成功 */
    MsgSuccess(message) {
      this.ComMessage({ message, type: 'success'})
    },

    /** 消息提示 警告 */
    MsgWarning(message) {
      this.ComMessage({message, type: 'warning' })
    },

    /** 消息提示 错误 */
    MsgError(message) {
      this.ComMessage({ message, type: 'error'})
    },

    /** 消息提示 */
    MsgInfo(message) {
      this.ComMessage({ message, type: 'info' })
    },

    /** 接口 错误提示 */
    ResMsgError(res) {
      const _message = `${res.msg} ${res.code ? `(状态码: ${res.code})` : ''}`
      this.ComMessage({message:_message, type:'error'})
    },

    /** 公用的消息提示方法 success  warning  error  info */
    ComMessage(props) {
      const {message, type = 'info', showClose = false} = props
      this.$message({
        showClose,
        message,
        type: type
      })
    },
  }
}





// WEBPACK FOOTER //
// ./src/mixins/comMessage.js